// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    useGetMemberVPosList,
    useAuthorization,
    useGetAllMerchantList,
    useGetMerchantEnrollmentBanks,
    postEnrollMerchantBank,
    postCancelEnrollmentByEnrollmentId,
    useEnrollMerchantBankWithExcel,
} from "../../../hooks";
import {
    Autocomplete,
    Box,
    FormControl,
    Stack,
    Switch,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
    Modal,
    Tabs,
    Tab,
    Card,
    CardContent,
    Grid,
    Divider,
    Fade
} from "@mui/material";
import { DeleteConfirmModal } from "../../molecules";
import React, { useMemo, useEffect, useState, useRef } from "react";
import { Button, Loading } from "../../atoms";
import { SoftPOSAuthorizationModal } from "../../molecules";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { zodResolver } from "@hookform/resolvers/zod";
import {
    merchantAuthFormSchema,
    MerchantAuthFormValuesType,
    merchantAuthInitialValues,
} from "./_formTypes";
import { useUserInfo } from "../../../store/User.state";
import GetAppIcon from '@mui/icons-material/GetApp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

export const MerchantSoftPOSAuthorizationForm = ({ merchantId: propMerchantId }: { merchantId?: number }) => {
    const theme = useTheme();
    const { showCreate } = useAuthorization();
    const [userInfo] = useUserInfo();

    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const { mutate: getMemberVPosList, data: rawMemberVPosList } = useGetMemberVPosList();
    const { mutate: getMerchantEnrollmentBanks, data: merchantEnrolledBanks } = useGetMerchantEnrollmentBanks();
    const [listData, setListData] = React.useState([]);
    const handleBack = () => navigate("/dashboard");
    const navigate = useNavigate();
    const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetAllMerchantList("ACTIVE");
    const { control, watch, handleSubmit, setValue, register } =
        useForm<MerchantAuthFormValuesType>({
            resolver: zodResolver(merchantAuthFormSchema),
            defaultValues: merchantAuthInitialValues,
        });
    const setSnackbar = useSetSnackBar();
    const merchantId = watch("merchantId");

    useEffect(() => {
        if (propMerchantId) {
            setValue("merchantId", propMerchantId);
            setSelectedDropdownMerchantId(propMerchantId);
        }
    }, [propMerchantId, setValue]);

    const merchantList = useMemo(() => {
        const activeMerchants = rawMerchantList?.data?.filter(
            (merchant) => merchant?.status === "ACTIVE"
        );


        if (userInfo.merchantId == 0) {
            return activeMerchants?.map(
                (rawPosType: { merchantName: string; merchantId: number }) => {
                    return {
                        label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
                        value: rawPosType.merchantId,
                    };
                }
            );
        } else {
            return activeMerchants
                ?.filter((rawPosType: { merchantName: string; merchantId: number }) => {
                    return rawPosType.merchantId === Number(userInfo.merchantId);
                })
                .map((filteredMerchant) => {
                    return {
                        label: filteredMerchant.merchantName + ` (${rawPosType.merchantId})`,
                        value: filteredMerchant.merchantId,
                    };
                });
        }
    }, [rawMerchantList?.data, userInfo?.merchantId]);

    const [selectedDropdownMerchantId, setSelectedDropdownMerchantId] = useState(0);

    useEffect(() => {
        getMemberVPosList({
            orderBy: "CreateDate",
            orderByDesc: true,
            status: "ACTIVE",
        });
    }, [getMemberVPosList]);

    useEffect(() => {

        getMerchantEnrollmentBanks(selectedDropdownMerchantId);

    }, [selectedDropdownMerchantId]);

    useEffect(() => {
        if (rawMemberVPosList?.data) {
            // Eğer memberPos varsa, listDataya bas.
            setListData(rawMemberVPosList?.data || []);
        }
    }, [rawMemberVPosList]);

    // MARK : Authorization Modal
    const [currentSelectedBank, setCurrentSelectedBank] = useState("");
    const [isMerchantAuthFormOpen, setIsMerchantAuthFormOpen] = useState(false);
    const handleMerchantAuthSubmit = (data: { terminalId: string; merchantId: string }) => {
        // Saved
        postEnrollMerchantBank({
            merchantId: selectedDropdownMerchantId,
            body: {
                merchantId: data.merchantId,
                terminalId: data.terminalId,
                bankCode: currentSelectedBank?.bankCode
            }
        })
            .then(data => {
                if (data.isSuccess) {
                    handleMerchantAuthClose();
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                } else {
                    // Show Error Message
                    setSnackbar({
                        severity: "error",
                        isOpen: true,
                        description: data.message,
                    });
                }
            });
    };

    const [isCancelEnrollmentModalOpen, setIsCancelEnrollmentModalOpen] = useState(false);
    const handleEnrollmentCancel = () => {

        postEnrollMerchantBank({
            merchantId: selectedDropdownMerchantId,
            body: {
                isCancel: true
            }
        })
            .then(data => {
                if (data.isSuccess) {
                    getMerchantEnrollmentBanks(selectedDropdownMerchantId);
                    setIsCancelEnrollmentModalOpen(false);
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                } else {
                    setSnackbar({
                        severity: "error",
                        isOpen: true,
                        description: data.message,
                    });
                }
            });
    }

    const handleCancelEnrollmentByEnrollmentId = (enrollmentId) => {

        postCancelEnrollmentByEnrollmentId({
            merchantId: selectedDropdownMerchantId,
            enrollmentId: enrollmentId
        })
            .then(data => {
                if (data.isSuccess) {
                    getMerchantEnrollmentBanks(selectedDropdownMerchantId);
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                } else {
                    setSnackbar({
                        severity: "error",
                        isOpen: true,
                        description: data.message,
                    });
                }
            });
    }

    const handleMerchantAuthClose = () => {
        getMerchantEnrollmentBanks(selectedDropdownMerchantId);
        setIsMerchantAuthFormOpen(false);
        setShowEnrollmentInfo(false);
        setCurrentEnrollmentInfo({});
    };


    const [showEnrollmentInfo, setShowEnrollmentInfo] = useState(false);
    const [currentEnrollmentInfo, setCurrentEnrollmentInfo] = useState({});
    const handleShowEnrollmentDetail = (bankCode: string) => {
        let currentEnrollmentDetail = merchantEnrolledBanks?.data?.find(x => x.bankCode == bankCode);
        if (currentEnrollmentDetail) {
            setShowEnrollmentInfo(true);
            setCurrentEnrollmentInfo(currentEnrollmentDetail);
            setIsMerchantAuthFormOpen(true);
        }
    }

    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const AuthorizationTabContent = () => (
        <Stack flex={1}>
            <Stack flex={1} p={2}>
                <Stack spacing={4}>
                    {!propMerchantId && (
                        <Stack width={isDesktop ? 800 : "auto"} spacing={3} direction="row">
                            <FormControl sx={{ flex: 1 }}>
                                {merchantList && (
                                    <Controller
                                        name="merchantId"
                                        control={control}
                                        defaultValue=""
                                        render={({ field: { onChange, value } }) => {
                                            const selectedMerchant = merchantList.find(
                                                (option) => option.value === value
                                            );

                                            return (
                                                <Autocomplete
                                                    id="merchantId"
                                                    options={merchantList}
                                                    getOptionSelected={(option, value) =>
                                                        option.value === value
                                                    }
                                                    getOptionLabel={(option) => option.label}
                                                    value={selectedMerchant || null}
                                                    onChange={(_, newValue) => {
                                                        setSelectedDropdownMerchantId(newValue ? newValue.value : 0);
                                                        onChange(newValue ? newValue.value : "");
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="İşyeri" />
                                                    )}
                                                />
                                            );
                                        }}
                                    />
                                )}
                            </FormControl>
                            {merchantId && (
                                <FormControl>
                                    <Button type="button" variant="contained" color="error" onClick={() => { setIsCancelEnrollmentModalOpen(true) }} text={"İptal Et"}>
                                    </Button>
                                </FormControl>
                            )}
                        </Stack>
                    )}
                    {isDesktop && <Box sx={{ flex: 1 }} />}
                    <Stack direction={isDesktop ? "row" : "column"} flexWrap="wrap">
                        {listData?.map((field: any, index: any) => (
                            <Box
                                my={1}
                                mr={isDesktop ? 3 : 0}
                                flex={isDesktop ? "44%" : "auto"}
                            >
                                <Stack
                                    key={index}
                                    py={1}
                                    px={2}
                                    justifyContent="space-between"
                                    alignItems="center"
                                    flex={1}
                                    direction="row"
                                    borderRadius={1}
                                    border={`1px solid ${!merchantId ? "#ADB6C4" : "#c4c4c4"}`}
                                >
                                    <Typography
                                        color={!merchantId ? "#ADB6C4" : "#41414D"}
                                    >{`${field.bankCode}-${field.bankName}`}</Typography>
                                    <Stack justifyContent={'right'} flex={1} direction={'row'}>
                                        <Switch
                                            // disabled={!merchantId || merchantId ? (merchantEnrolledBanks?.data?.find(x => x.bankCode == field.bankCode) ? true : false) : false}
                                            checked={merchantId ? (merchantEnrolledBanks?.data?.find(x => x.bankCode == field.bankCode) ? true : false) : false}
                                            onChange={(e) => {
                                                const newListData = [...listData];
                                                setCurrentSelectedBank(newListData[index]);

                                                if (e.target.checked) {
                                                    setIsMerchantAuthFormOpen(true);
                                                } else {
                                                    handleCancelEnrollmentByEnrollmentId(merchantEnrolledBanks?.data?.find(x => x.bankCode == field.bankCode)?.enrollmentId);
                                                }
                                            }}
                                        />
                                        {merchantEnrolledBanks?.data?.find(x => x.bankCode == field.bankCode) && (<Button text="Detay" onClick={() => {
                                            handleShowEnrollmentDetail(field.bankCode)
                                        }}>Detay</Button>)}
                                    </Stack>
                                </Stack>
                            </Box>
                        ))}
                    </Stack>
                </Stack>
            </Stack>
            <Stack
                borderTop="1px solid #E6E9ED"
                py={2}
                direction="row"
                justifyContent="flex-end"
            >
                <Button onClick={handleBack} sx={{ mx: 2 }} text={"Iptal"} />
            </Stack>
            <SoftPOSAuthorizationModal open={isMerchantAuthFormOpen} handleClose={handleMerchantAuthClose} handleSubmit={handleMerchantAuthSubmit} onlyInfo={showEnrollmentInfo} detail={currentEnrollmentInfo} />
            <DeleteConfirmModal
                isOpen={isCancelEnrollmentModalOpen}
                onClose={() => { setIsCancelEnrollmentModalOpen(false); }}
                title="İptal Onayı"
                content="Seçili işyerinin SoftPOS yetkilerini iptal etmek istiyor musunuz?"
                confirmButtonText="Evet"
                closeButtonText="Hayır"
                onConfirm={() => handleEnrollmentCancel()}
            ></DeleteConfirmModal>
        </Stack>
    );

    const ExcelUploadTabContent = () => {
        const [file, setFile] = useState<File | null>(null);
        const [uploadCompleted, setUploadCompleted] = useState(false);
        const [uploadSuccessful, setUploadSuccessful] = useState(false);
        const [uploadResults, setUploadResults] = useState<any>(null);
        const [progress, setProgress] = useState(0);
        const fileInput = useRef<HTMLInputElement>(null);

        const { mutate: enrollMerchantBankWithExcel, isLoading } = useEnrollMerchantBankWithExcel();
        const setSnackbar = useSetSnackBar();

        const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const selectedFile = e.target.files?.[0];
            if (selectedFile) {
                if (selectedFile.name.endsWith(".xlsx")) {
                    setFile(selectedFile);
                    setUploadCompleted(false);
                    setProgress(0);
                } else {
                    setFile(null);
                    if (fileInput.current) fileInput.current.value = "";
                    setSnackbar({
                        severity: "error",
                        isOpen: true,
                        description: "Lütfen .xlsx formatında dosya yükleyiniz",
                    });
                }
            }
        };

        const handleUpload = async () => {
            if (!file) return;
            setProgress(15);

            const formData = new FormData();
            formData.append("files", file);

            enrollMerchantBankWithExcel(formData, {
                onSuccess: (data) => {
                    console.log("Upload response:", data); // Debug line
                    setProgress(100);
                    setUploadCompleted(true);

                    const resultData = data?.data || data?.result || data; // handle flexible structures

                    if (data.isSuccess && resultData) {
                        setUploadSuccessful(true);
                        setUploadResults(resultData);
                        setSnackbar({
                            severity: "success",
                            isOpen: true,
                            description: data.message || "Dosya başarıyla yüklendi",
                        });
                    } else {
                        setUploadSuccessful(false);
                        setUploadResults(resultData || null);
                        setSnackbar({
                            severity: "error",
                            isOpen: true,
                            description: data.message || "Dosya yüklenirken hata oluştu",
                        });
                    }
                },
                onError: () => {
                    setProgress(100);
                    setUploadCompleted(true);
                    setUploadSuccessful(false);
                    setSnackbar({
                        severity: "error",
                        isOpen: true,
                        description: "Dosya yüklenirken hata oluştu",
                    });
                },
            });
        };

        return (
            <Stack spacing={6} p={4} maxWidth={900} mx="auto">
                {/* STEP 1 */}
                <Box>
                    <Typography variant="h6" fontWeight={600} mb={1}>
                        1️⃣ Örnek Excel Dosyasını İndirin
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={3}>
                        Yükleme işlemine başlamadan önce şablonu indirip uygun formatta doldurun.
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<GetAppIcon />}
                        href="/files/EnrollMerchantBankWithExcel.xlsx"
                        download
                        sx={{
                            height: 48,
                            width: 220,
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                        }}
                        text="Örnek Şablonu İndir"
                    />
                </Box>

                <Divider />

                {/* STEP 2 */}
                <Box>
                    <Typography variant="h6" fontWeight={600} mb={1}>
                        2️⃣ Excel Dosyasını Yükleyin
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={3}>
                        Dosyayı sürükleyip bırakabilir veya seç butonunu kullanabilirsiniz.
                    </Typography>

                    {/* Upload Area */}
                    <Box
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                            e.preventDefault();
                            const droppedFile = e.dataTransfer.files[0];
                            if (droppedFile && droppedFile.name.endsWith(".xlsx")) {
                                setFile(droppedFile);
                            } else {
                                setSnackbar({
                                    severity: "error",
                                    isOpen: true,
                                    description: "Lütfen yalnızca .xlsx dosyası yükleyiniz",
                                });
                            }
                        }}
                        onClick={() => fileInput.current?.click()}
                        sx={{
                            border: "2px dashed #90caf9",
                            borderRadius: "12px",
                            p: 6,
                            textAlign: "center",
                            bgcolor: file ? "#E3F2FD" : "#FAFAFA",
                            color: "#444",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            "&:hover": {
                                borderColor: "#42a5f5",
                                bgcolor: "#E3F2FD",
                            },
                        }}
                    >
                        <input
                            ref={fileInput}
                            type="file"
                            accept=".xlsx"
                            onChange={handleFileChange}
                            hidden
                        />
                        <Typography variant="h6" fontWeight={500}>
                            {file ? file.name : "Dosyayı buraya sürükleyin veya tıklayın"}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Yalnızca .xlsx dosyaları desteklenir
                        </Typography>
                    </Box>

                    {/* Upload Button + Progress */}
                    <Stack direction="row" justifyContent="space-between" alignItems="center" mt={3}>
                        <Button
                            variant="contained"
                            disabled={!file || isLoading}
                            onClick={handleUpload}
                            sx={{
                                width: 180,
                                height: 48,
                                borderRadius: "8px",
                                textTransform: "none",
                                fontWeight: 600,
                            }}
                            text={isLoading ? <Loading size={24} /> : "Yüklemeyi Başlat"}
                        />
                        {isLoading && (
                            <Box flex={1} ml={4}>
                                <Box
                                    sx={{
                                        height: 6,
                                        bgcolor: "#E0E0E0",
                                        borderRadius: "3px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            height: "100%",
                                            width: `${progress}%`,
                                            bgcolor: "#1976d2",
                                            transition: "width 0.4s ease",
                                        }}
                                    />
                                </Box>
                                <Typography variant="caption" color="primary">
                                    Dosya yükleniyor...
                                </Typography>
                            </Box>
                        )}
                    </Stack>
                </Box>

                <Divider />

                {/* STEP 3: Results */}
                {uploadCompleted && (
                    <Fade in={uploadCompleted}>
                        <Box
                            p={4}
                            borderRadius={3}
                            sx={{
                                bgcolor: uploadSuccessful ? "#E8F5E9" : "#FFEBEE",
                                border: `1px solid ${uploadSuccessful ? "#81C784" : "#EF9A9A"
                                    }`,
                            }}
                        >
                            <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                                {uploadSuccessful ? (
                                    <CheckCircleIcon color="success" fontSize="large" />
                                ) : (
                                    <ErrorIcon color="error" fontSize="large" />
                                )}
                                <Typography variant="h6">
                                    {uploadSuccessful
                                        ? "Yükleme Başarıyla Tamamlandı"
                                        : "Yükleme Sırasında Hata Oluştu"}
                                </Typography>
                            </Stack>

                            {uploadResults && (
                                <>
                                    <Stack direction="row" spacing={3} mb={2}>
                                        <Typography>
                                            <strong>Toplam:</strong> {uploadResults.totalRecord}
                                        </Typography>
                                        <Typography color="success.main">
                                            <strong>Başarılı:</strong> {uploadResults.successRecord}
                                        </Typography>
                                        <Typography color="error.main">
                                            <strong>Başarısız:</strong> {uploadResults.failRecord}
                                        </Typography>
                                    </Stack>

                                    {uploadResults.errorMessages?.length > 0 && (
                                        <Box mt={2}>
                                            <Typography
                                                variant="subtitle1"
                                                gutterBottom
                                                color="error"
                                                fontWeight={600}
                                            >
                                                Hata Mesajları
                                            </Typography>
                                            <Stack spacing={1}>
                                                {uploadResults.errorMessages.map(
                                                    (error: string, index: number) => (
                                                        <Typography
                                                            key={index}
                                                            variant="body2"
                                                            color="error"
                                                            display="flex"
                                                            alignItems="center"
                                                            gap={1}
                                                        >
                                                            <ErrorIcon fontSize="small" />
                                                            {error}
                                                        </Typography>
                                                    )
                                                )}
                                            </Stack>
                                        </Box>
                                    )}
                                </>
                            )}
                        </Box>
                    </Fade>
                )}
            </Stack>
        );
    };


    return (
        <Stack flex={1}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label="Tekli Yetkilendirme" />
                    <Tab label="Excel ile Yetkilendirme" />
                </Tabs>
            </Box>

            {activeTab === 0 ? (
                <AuthorizationTabContent />
            ) : (
                <ExcelUploadTabContent />
            )}
        </Stack>
    );
};